const headerStyles = {
  headerStyle: {
    whiteSpace: "nowrap",
  },
  dataStyle: {
    textAlign: "left",
  },
  align: "left",
};

export const userManagementTabOptions = [
  {
    label: "All Users",
    value: "all_users",
  },
  {
    label: "Requested",
    value: "requested",
  },
];
export const stateManagementTabOptions = [
  {
    label: "State",
    value: "state",
  },
  {
    label: "Staff",
    value: "staff",
  },
];

export const userManagementFilterOptions = [
  {
    label: "Filter",
    value: "filter_1",
  },
  {
    label: "Filter 2",
    value: "filter_2",
  },
  {
    label: "Filter 3",
    value: "filter_3",
  },
];

export const stateManagementFilterOptions = [
  {
    label: "Filter",
    value: "filter_1",
  },
  {
    label: "Filter 2",
    value: "filter_2",
  },
  {
    label: "Filter 3",
    value: "filter_3",
  },
];

export const inventoryManagementFilterOptions = [
  {
    label: "All Products",
    value: "all_products",
  },
  {
    label: "Low Stock",
    value: "low_stock",
  },
  {
    label: "Out of Stock",
    value: "out_of_stock",
  },
  {
    label: "Published",
    value: "published",
  },
  {
    label: "Draft",
    value: "draft",
  },
];

export const royaltyProgramFilterOptions = [
  {
    label: "All Status",
    value: "all",
  },
  {
    label: "Points Earned",
    value: "points_earned",
  },
  {
    label: "Points Spent",
    value: "points_spent",
  },
];

export const userManagementTableHeaders = [
  { label: "Users", value: "name", sortable: false },
  { label: "Email Address", value: "email", sortable: false },
  { label: "Revenue", value: "totalRevenue", sortable: true },
  { label: "Order Frequency", value: "ordersFrequency", sortable: true },
  { label: "Recently Ordered", value: "lastOrderDate", sortable: true },
  { label: "Status", value: "status", sortable: false },
  { label: "Action", value: "action", sortable: false },
];

export const stateManagementTableHeaders = [
  { label: "Users", value: "name" },
  { label: "State", value: "state" },
  { label: "Warehouse", value: "warehouse" },
  { label: "Action", value: "action" },
];

export const contactManagementTableHeaders = [
  { label: "Users", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone Number", value: "phone" },
  { label: "Date", value: "date" },
  { label: "Action", value: "action" },
];

export const inventoryManagementTableHeaders = [
  { label: "Product", value: "name" },
  { label: "MPN", value: "mpn" },
  { label: "Brand", value: "brand" },
  { label: "States", value: "states" },
  { label: "Price", value: "price" },
  { label: "Created At", value: "createdAt" },
  { label: "Action", value: "action" },
];

export const orderManagementTabOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Pending",
    value: "payment-pending",
  },
  {
    label: "Completed",
    value: "payment-completed",
  },
];

export const orderManagementFilterOptions = [
  {
    label: "All Status",
    value: "all_status",
  },
  {
    label: "In Progress",
    value: "in_progress",
  },
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
];

export const orderManagementTableHeaders = [
  { label: "Order ID", value: "orderId" },
  { label: "Customer", value: "customer" },
  { label: "Products", value: "products" },
  { label: "Total", value: "total" },
  { label: "States", value: "states" },
  { label: "Status", value: "status" },
  { label: "Created At", value: "createdAt" },
  { label: "Action", value: "action" },
];

export const activityLogsTabOptions = [
  {
    label: "All Time",
    value: "all_time",
  },
  {
    label: "12 Months",
    value: "12_months",
  },
  {
    label: "30 Days",
    value: "30_days",
  },
  {
    label: "7 Days",
    value: "7_days",
  },
];

export const royaltyProgramTableHeaders = [
  { label: "Order Number", value: "orderId" },
  { label: "Total Products", value: "totalProducts" },
  { label: "Total Amount", value: "totalAmount" },
  { label: "Order Date", value: "createdAt" },
  { label: "Points Eraned", value: "pointsEraned" },
];
export const stateOptions = [
  {
    label: "California",
    value: "california",
  },
  {
    label: "New York",
    value: "new york",
  },
  {
    label: "Arizona",
    value: "arizona",
  },
  {
    label: "Florida",
    value: "florida",
  },
  {
    label: "Texas",
    value: "texas",
  },
  {
    label: "Alaska",
    value: "alaska",
  },
];
export const roleManagementHeaders = [
  { label: "#", value: "sno" },
  { label: "Role Name", value: "name" },
  { label: "Created", value: "createdAt" },
  { label: "Actions", value: "actions" },
];
export const staffManagementTableHeaders = [
  { label: "#", value: "sno" },
  { label: "Staff Name", value: "name" },
  { label: "Role", value: "role" },
  { label: "States", value: "states" },
  { label: "Created At", value: "createdAt" },
  { label: "Actions", value: "actions" },
];
export const statusOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "system-deactivated",
  },
];
export const warehouseManagementTableHeaders = [
  { label: "Name", value: "name", ...headerStyles },
  { label: "Location No", value: "locationNo", ...headerStyles },
  { label: "Address", value: "address1", ...headerStyles },
  { label: "Phone", value: "addrPhone", ...headerStyles },
  { label: "Country", value: "country", ...headerStyles },
  { label: "City", value: "city", ...headerStyles },
  { label: "State", value: "state", ...headerStyles },
  { label: "Zip Code", value: "zip", ...headerStyles },
  { label: "Actions", value: "actions", ...headerStyles },
];

export const brandManagementTableHeaders = [
  { label: "Name", value: "name", ...headerStyles },
  { label: "Discount (%)", value: "percentage", ...headerStyles },
  { label: "Actions", value: "actions", ...headerStyles },
];
export const promotionsManagementTableHeaders = [
  { label: "#", value: "sno", ...headerStyles },
  { label: "Promotion Title", value: "title", ...headerStyles },
  { label: "Created At", value: "createdAt", ...headerStyles },
  { label: "Actions", value: "actions", ...headerStyles },
];
export const categoryManagementTableHeaders = [
  { label: "Name", value: "name", ...headerStyles },
  { label: "Created", value: "createdAt", ...headerStyles },
  { label: "Actions", value: "actions", ...headerStyles },
];
export const topSellingHeaders = [
  { label: "Product", value: "name" },
  { label: "MPN", value: "mpn" },
  { label: "Brand", value: "brand" },
  { label: "States", value: "states" },
  { label: "Price", value: "price" },
  { label: "Action", value: "action" },
];
